import React, { useEffect, useState } from 'react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const hero = document.getElementById('hero');
      const finalCta = document.getElementById('final-cta');
      if (!hero || !finalCta) return;
      const heroBottom = hero.getBoundingClientRect().bottom;
      const finalTop = finalCta.getBoundingClientRect().top;
      // Show when hero is out of view, hide when final CTA is in view
      if (heroBottom < 0 && finalTop > window.innerHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 bg-ivory p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] shadow-[0_-4px_24px_rgba(0,0,0,0.1)] z-50 transition-transform duration-500 ease-in-out ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-241">
      <div className="max-w-[480px] mx-auto" data-id="element-242">
        <a href="#investment" onClick={e => {
        e.preventDefault();
        document.getElementById('investment')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="block w-full bg-plum text-white text-center py-4 rounded-[6px] text-[14px] font-medium tracking-[0.03em] active:scale-[0.98] transition-transform" data-id="element-243">
          Quiero recuperar mi eje →
        </a>
      </div>
    </div>;
}